import { useState, useEffect } from "react";
import { Row, Col, Button, Form, Alert, Modal, ProgressBar, Card, Nav } from "react-bootstrap";

import DateTimePicker from "react-datetime-picker";
import moment from "moment";
import _ from "lodash";
import axios from "axios";
import Utils from "../../common/Utils";

const UserForm = (props) => {
  const [data, setData] = useState(props.mode === 2 ? props.data : {});
  const [roles, setRoles] = useState([]);
  const [uroles, setURoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [adding, setAdding] = useState(false);
  const [fvals, setFVals] = useState({});
  const [tab, setTab] = useState("user");
  const [calc, setCalc] = useState({'holidayHours': 0, 'weeklyHours': 0, 'yearlyHours': 0}); 

  const fetchRoles = () => {
    if (tab === "role") {
      setLoading(true);
      axios
        .get(Utils.apiUrl(`users/fetchuserroles/${data.id}`), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            let rls = _.get(res, "data.roles", []);
            setRoles(rls);
            setURoles(
              _.map(
                _.filter(rls, (r) => r.selected === "1"),
                (r) => r.id
              )
            );
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(true);
          console.log(err);
        });
    }
  };
  useEffect(fetchRoles, [tab]);

  useEffect(() => {
    if (props.mode === 2) {
      let leaves = parseFloat(_.get(data,'leaves',0));
      let whrs = _.split(_.get(data,'wday_hours',''),',');
      whrs = _.sum(_.map(_.compact(whrs),parseFloat));
      console.log(whrs);
      setCalc({'holidayHours': Math.floor(whrs*leaves*52/100), 'weeklyHours': whrs, 'yearlyHours': whrs*52});
    }
  },[]);

  const saveUser = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    setAdding(true);

    let pvals = {
      designation: frm.designation.value,
      title: frm.title.value,
      firstname: frm.firstname.value,
      middlename: frm.middlename.value,
      lastname: frm.lastname.value,
      email: frm.email.value,
      phone: frm.phone.value,
      wdays: [],
      wday_hours: [],
      leaves: frm.leaves.value,
      joining_date: frm.joining_date.value,
      is_cqc : frm.is_cqc.checked?1:0,
      is_rota : frm.is_rota.checked?1:0,
    };

    if (props.mode === 2) {
      pvals = {
        ...pvals,
        id: data.id,
      };
    }
console.log('userform',frm.elements);
    frm.elements["wdays[]"].forEach((w) => {
      if (w.checked) {
        pvals.wdays.push(w.value);
        pvals.wday_hours[w.value] = frm.elements[`wday_hours[${w.value}]`].value;
      }
    });

    setData({ ...pvals, wdays: pvals.wdays.join(",") });

    axios
      .post(Utils.apiUrl("users/frontsave"), Utils.postVars(pvals), Utils.apiHeaders())
      .then((res) => {
        setAdding(false);
        if (res.data.success) {
          props.onAdd();
        } else {
          window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const saveURoles = () => {
    setAdding(true);

    axios
      .post(Utils.apiUrl(`users/saveuserroles/${data.id}`), `rids=${uroles.join(",")}`, Utils.apiHeaders())
      .then((res) => {
        setAdding(false);
        if (res.data.success) {
          window.alert(res.data.message);
        } else {
          window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const autoCalculate = (e) => {
    const frm = e.currentTarget.form;
    let leaves = parseFloat(frm.leaves.value);
    leaves = _.isNaN(leaves) ? 0 : leaves;
    let whrs = 0;
    _.each(document.querySelectorAll('input.wdays'), (wd, idx)  => whrs += wd.checked ? parseFloat(document.querySelectorAll('.wday_hours')[idx].value) : 0);
    setCalc({'holidayHours': Math.floor(whrs*leaves*52/100), 'weeklyHours': whrs, 'yearlyHours': whrs*52});
  };

  const renderWorkingDays = () => {
    return (
      <div className="col-lg-12">
        <label className="form-label">Select weekdays when this user is working:</label>
        <Row className="m-2 g-3 pb-3 px-4 bg-light border-1">
          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((v, idx) => (
            <Col sm={6} md={4} lg={3} xl={2}>
              <div className="d-flex">
                <div><input
                    type="checkbox"
                    name="wdays[]"
                    value={idx + 1}
                    id={`chk_wday_${idx + 1}`}
                    className="wdays"
                    onChange={autoCalculate}
                    defaultChecked={_.get(data, "wdays", "").split(",").includes(idx + 1 + "")}
                    onClick={(e) => e.currentTarget.parentNode.nextElementSibling.classList[e.currentTarget.checked ? 'remove' : 'add']('d-none')}
                  />
                  <label className="mx-2" for={`chk_wday_${idx + 1}`}>{v}</label>
                </div>
                <div className={_.get(data, "wdays", "").split(",").includes(idx + 1 + "") ? '' : 'd-none'}>
                  <select name={`wday_hours[${idx+1}]`} className="wday_hours" wday={idx+1} onChange={autoCalculate} defaultValue={_.get(_.split(_.get(data, "wday_hours", ""),','),idx+1,'')}>
                    {_.map(_.fill(new Array(48),0),(v,idx2) => <option key={idx2+1} value={(idx2+1)/4}>{Utils.addZero(((idx2+1)/4).toFixed(2))}</option>)}
                  </select>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  };

  const renderForm = () => {
    return (
      <Form className="needs-validation" novalidate onSubmit={saveUser}>

        <div className="row">
          <div className="col-lg-4 mb-3">
            <label className="form-label">Designation *</label>
            <input
              type="text"
              required
              name="designation"
              maxlength="256"
              className="form-control"
              placeholder="Designation"
              defaultValue={_.get(data, "designation", "")}
            />
          </div>
          <div className="col-lg-4 mb-3">
            <label className="form-label">Phone *</label>
            <input
              type="phone"
              name="phone"
              required
              maxlength="20"
              pattern="([\+]*)([0-9]+)"
              className="form-control"
              placeholder="Phone number"
              defaultValue={_.get(data, "phone", "")}
            />
            <div className="invalid-feedback">Please fill a valid Phone Number</div>
          </div>

          <div className="col-lg-4 mb-3">
            <label className="form-label">Email *</label>
            <input
              type="email"
              name="email"
              required
              maxlength="255"
              className="form-control"
              placeholder="Email Address"
              defaultValue={_.get(data, "email", "")}
            />
            <div className="invalid-feedback">Please fill a valid Email Address</div>
          </div>

          
        </div>


        <div className="row">
          <div className="col-lg-2 mb-3">
            <label className="form-label">Title *</label>
            <select className="form-select" name="title" required defaultValue={_.get(data, "title", "")}>
              {["Mr.", "Ms.", "Dr."].map((t) => (
                <option value={t}>{t}</option>
              ))}
            </select>
            <div className="invalid-feedback">Please Select title of User</div>
          </div>
          <div className="col-lg-4 mb-3">
            <label className="form-label">FirstName *</label>
            <input
              type="text"
              name="firstname"
              required
              maxlength="30"
              className="form-control"
              placeholder="First name"
              defaultValue={_.get(data, "firstname", "")}
            />
            <div className="invalid-feedback">Please fill firstname of User</div>
          </div>
          <div className="col-lg-3 mb-3">
            <label className="form-label">MiddleName</label>
            <input
              type="text"
              name="middlename"
              maxlength="30"
              className="form-control"
              placeholder="Middle name"
              defaultValue={_.get(data, "middlename", "")}
            />
          </div>
          <div className="col-lg-3 mb-3">
            <label className="form-label">LastName *</label>
            <input
              type="text"
              name="lastname"
              required
              maxlength="30"
              className="form-control"
              placeholder="Last name"
              defaultValue={_.get(data, "lastname", "")}
            />
            <div className="invalid-feedback">Please fill lastname of User</div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-2 mb-3">
            <div className="ui-front">
              <label for="joining_date" className="form-label">
                Joining On:
              </label>
              <input
                type="date"
                className="form-control"
                name="joining_date"
                defaultValue={_.get(data, "joining_date", moment().format("Y-M-D"))}
                // min={moment().format("YYYY-MM-DD")}
                min={_.get(data, "joining_date", moment().format("YYYY-MM-DD"))}
                // disabled={_.get(data, "joining_date", false)}
              />
            </div>
          </div>

          <div className="col-lg-3 mb-3">
            <div className="ui-front">
              <label for="leaves" className="form-label">
                Holidays allowed in a year*:
              </label>
              <div className="d-flex">
                <input
                  type="number"
                  className="form-control"
                  name="leaves"
                  required
                  onChange={autoCalculate}
                  defaultValue={_.get(data, "leaves", 0)}
                  min={0}
                  step={0.01}
                  max={100}
                  // disabled={_.get(data, "joining_date", false)}
                />
                <div className="ms-2 p-2">%</div>
              </div>
            </div>
          </div>
          <div className="col-lg-2 mb-3">
            <label className="form-label">Total Holiday hours in a year*: </label>
            <div className="text-secondary"><b>{calc.holidayHours} Hrs.</b></div>
          </div>
          
          <div className="col-lg-2 mb-3">
            <label className="form-label">Weekly Working hours*:</label>
            <div className="text-secondary"><b>{calc.weeklyHours} Hrs.</b></div>
          </div>
          <div className="col-lg-3 mb-3">
            <label className="form-label">Working hours in a year*:</label>
            <div className="text-secondary"><b>{calc.yearlyHours} Hrs.</b></div>
          </div>
          
        </div>

        <div className="row">
          {renderWorkingDays()}
        </div>

        <div className="row">
          <div className="col-lg-6">
            <Row className="m-2 g-3 pb-3 px-4 bg-light border-1">
              <Col sm={6} md={4} lg={3}>
                <input
                  type="checkbox"
                  name="is_cqc"
                  value={0}
                  id={`is_cqc`}
                  defaultChecked={(_.get(data, "is_cqc", ""))==1?true:false}
                />
                <label className="mx-2" for={`is_cqc`}>
                  CQC User
                </label>
              </Col>
            </Row>
          </div>
          <div className="col-lg-6">
            <Row className="m-2 g-3 pb-3 px-4 bg-light border-1">
              <Col sm={6} md={4} lg={3}>
                <input
                  type="checkbox"
                  name="is_rota"
                  value={0}
                  id={`is_rota`}
                  defaultChecked={(_.get(data, "is_rota", ""))==1?true:false}
                />
                <label className="mx-2" for={`is_rota`}>
                  Can manage Rota
                </label>
              </Col>
            </Row>
          </div>


          <div className="col-lg-12 mb-3">
            <Button type="submit" variant="primary" className="mt-2 p-3">
              Save User
            </Button>
          </div>
        </div>
      </Form>
    );
  };

  const toggleURoles = (rid) => {
    if (uroles.includes(rid)) {
      setURoles(_.filter(uroles, (ur) => ur !== rid));
    } else {
      setURoles([...uroles, rid]);
    }
  };

  const renderUserRoles = () => {
    return (
      <>
        {loading && (
          <Alert variant="info" className="p-3">
            <p className="loading-msg">fetching user roles..</p>
            <ProgressBar variant="info" animated now={100} />
          </Alert>
        )}
        {!loading && (
          <div>
            <b>Select Roles for this user:</b>
            <div style={{ backgroundColor: "#f0f0f0" }} className="d-flex flex-wrap p-2">
              {roles.map((r) => (
                <Alert variant="light" className="m-1 py-1 clickable" onClick={() => toggleURoles(r.id)}>
                  <input type="checkbox" value={r.id} checked={uroles.includes(r.id)} onClick={() => toggleURoles(r.id)} /> {r.name}
                </Alert>
              ))}
            </div>
            <Button variant="primary" className="p-3 px-5 mt-2" onClick={saveURoles}>
              Save
            </Button>
          </div>
        )}
      </>
    );
  };

  return (
    <Card className="my-3">
      <Card.Body>
        {adding && (
          <Alert variant="info" className="p-3">
            <p className="loading-msg">saving data..</p>
            <ProgressBar variant="info" animated now={100} />
          </Alert>
        )}
        {!adding && (
          <>
            {props.mode === 2 && (
              <>
                <Nav variant="tabs" defaultActiveKey={tab}>
                  <Nav.Item>
                    <Nav.Link eventKey="user" onSelect={() => setTab("user")}>
                      Edit Details
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="role" onSelect={() => setTab("role")}>
                      User Roles
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <div className="mt-4">
                  {tab === "user" && renderForm()}
                  {tab === "role" && renderUserRoles()}
                </div>
              </>
            )}
            {props.mode === 1 && renderForm()}
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default UserForm;
